import React, { useRef, useState, useEffect } from 'react'
import styles from './InfoItem.module.css'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Checkbox, Col, message, Row, Switch } from 'antd'
import { getMoneyDate } from '../../../util/currencyUnit'

export default function InfoItem(props) {
  const dispatch = useDispatch()
  const [confirmInfo, setConfirmInfo] = useState({})
  const [messageApi, contextHolder] = message.useMessage()

  return (
    <tr className={styles.tr1}>
      <td className={styles.td1}>{props.item.transaction_id}</td>
      <td className={styles.td1}>{props.item.pay_type == 1 ? "微信" : "支付宝"}</td>
      <td className={styles.td1}>{props.item.shengfen_name}</td>
      <td className={styles.td1}>{props.item.shi_name}</td>
      <td className={styles.td1}>{props.item.quxian_name}</td>
      <td className={styles.td1}>{getMoneyDate("fen",props.item.dingdan_amount)}</td>
      <td className={styles.td1}>{props.item.user_type == 1 ? "普通账户" : "教师账户"}</td>
      <td className={styles.td1}>{props.item.school_name}</td>
      <td className={styles.td1}>{props.item.user_login}</td>
      <td className={styles.td1}>{props.item.name}</td>
      <td className={styles.td1}>{props.item.jiaofei_time}</td>
      {contextHolder}
    </tr>
  )
}
// export default PaymentInfoList;
